import PolicyTemplate from '../components/o_series/common/PoliciesTemplate'
import s from '../components/o_series/common/Policies.module.css'

const CookiePolicy: React.FC = () => {
  return (
    <PolicyTemplate>
      <div className={`px-2 md:px-0 container mx-auto pb-10 ${s.policy}`}>
        <h3 className="mb-4 font-bold text-lg" id="cookies_policy">
          Cookie Policy
        </h3>
        <ol>
          <li className={s.paragraph}>
            This website, portal and application KetoGo.app (hereinafter –
            “Site”) uses cookies. If you have agreed, in addition to cookies
            that ensure the functioning of the Site, other cookies, web beacons,
            pixels or similar storage technology may be placed on your browser
            or device from which you access our Site. This policy explains what
            cookies this Site uses and for which purposes.
          </li>
          <li className={s.paragraph}>
            Personal data controller is Nutrameg SIA, registration number:
            50203370651, VAT number: LV50203370651, legal address: Lastadijas
            Street 6, LV-1050, Riga, Latvia. Email: hello@ketogo.app
          </li>
          <li>
            <strong>What are cookies and for what purposes we use them?</strong>
          </li>
          <ol>
            <li>
              Cookies are small text files, which are stored on your device when
              you visit our Site. The browser you use, uses the cookies to
              forward the information back to the Site at each subsequent visit,
              for the Site to recognize the user and to remember the user`s
              choices (for example, choice of language, login information and
              other settings). This can make your next visit easier and site
              more useful to you.
            </li>
            <li>
              We use different types of cookies. When you access the Site, we
              will place strictly necessary cookies on your browser or device.
              Other types of cookies will be stored only if you have accepted
              the use of such cookies. Here are more details on cookies, which
              may be stored on your device or browser when you access our Site.
            </li>
            <ol>
              <li>Strictly necessary cookies</li>
              <ol>
                <li>
                  Strictly necessary cookies help to make the Site easy to use
                  by providing basic functions such as page navigation, language
                  selection, authorization and filling in forms. The Site may
                  not function without these cookies and they cannot be
                  disabled. These cookies do not reveal the user`s identity or
                  collect user information. They are stored on the user`s device
                  until the browser is closed.
                </li>
              </ol>
              <li>Analytical cookies</li>
              <ol>
                <li>
                  Analytical cookies let us count Site visits and traffic
                  sources so we can measure and improve the performance of our
                  Site. They help us to know which pages are the most and least
                  popular and see how visitors move around the Site. All
                  information these cookies collect is in aggregated form. For
                  analytical and statistical purposes, we may use third party,
                  for example, Google Analytics cookies, which may be stored on
                  the device or browser permanently.
                </li>
              </ol>
              <li>Marketing cookies</li>
              <ol>
                <li>
                  These cookies provide advertising and marketing communication,
                  which are related to the interests of Site users. They can be
                  used by third parties and service providers to create an
                  interest profile and display relevant ads on other webpages.
                  These cookies do not store personally identifiable
                  information, but are based on the unique identifier of the
                  browser and the device. These cookies remember information
                  about your visit to the Site and may be used to display
                  personalized ads on social networks and other sites. Disabling
                  these cookies will give you less personalized advertising. For
                  advertising purposes, we may use third-party cookies, such as
                  Facebook or Google cookies, which may be stored on your device
                  or browser permanently.
                </li>
              </ol>
            </ol>
          </ol>
          <li>
            <strong>How to control cookies</strong>
          </li>
          <ol>
            <li>
              When visiting our Site, you are shown an informative statement
              that the Site uses cookies and asked for your consent to enable
              analytical and marketing cookies. If you wish to withdraw your
              consent or change cookie settings, you can do so by clicking the
              cookie settings button above.
            </li>
            <li>
              You can withdraw your consent for analytical and/or marketing
              cookies as well as delete all cookies stored in your browser by
              deleting your browser cookie history. You can also set up your
              browser to block cookies being saved. By clicking on “help” button
              in your browser, you can find instructions on how to prevent the
              browser from storing cookies, as well as what cookies are stored
              already and delete them, if you want to. Changes to the settings
              must be made for each browser that you use.
            </li>
            <li>
              You can also separately opt-out from having your website activity
              available to Google Analytics by installing the Google Analytics
              opt-out browser add-on, which prevents sharing information about
              your website visit with Google Analytics. Link to the add-on and
              for more information:
              https://support.google.com/analytics/answer/18188.
            </li>
          </ol>
          <li>
            <strong>Contact information</strong>
          </li>
          <ol>
            <li>
              If you have any questions concerning this Cookie Policy or you
              wish to exercise your data subject rights, please contact us by
              writing to hello@ketogo.app
              <br /> <br /> Nutrameg SIA, registration number: 50203370651, VAT
              number: LV50203370651, legal address: Lastadijas Street 6,
              LV-1050, Riga, Latvia
              <br />
            </li>
          </ol>
          <li>
            <strong>Cookie Policy changes</strong>
          </li>
          <ol>
            <li>
              We reserve the right to change and amend this Cookie Policy from
              time to time. The amendments take effect as soon as they are
              uploaded to the Site. In the event of a dispute as to the terms of
              this Cookie Policy in different languages, the English version
              shall prevail.
            </li>
          </ol>
        </ol>
        <p className="mt-4 text-right text-lg">
          This Cookie Policy is effective as of 22.04.2021
        </p>
      </div>
    </PolicyTemplate>
  )
}

export default CookiePolicy
